const parseStringToNumber = (value?: string): number => {
  const parsedValue = Number(value?.replaceAll('.', ''))
  return Number.isNaN(parsedValue) ? 0 : parsedValue
}

export default parseStringToNumber
